import { styled } from '@mui/material';
import { Header } from '../Header';
import { Outlet } from 'react-router-dom';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { useAuth } from '@frontend/features/auth/hooks/useAuth';
import { PrivateLogin } from '@frontend/features/auth/components/PrivateLogin';
import { useEffect, useState } from 'react';
import { FLIGHT_SEARCH_UNDER_HEADER_HEIGHT, HOTEL_SEARCH_UNDER_HEADER_HEIGHT } from '../../constants/layout';
import { useTravelServicesUpdates } from '@frontend/features/travel-services/hooks/useTravelServicesUpdates';
import { CONFIG } from '@frontend/config';
import { InboxProvider } from '@frontend/features/inbox/InboxContext';

interface LayoutProps {
  noLargeDownHeader?: boolean;
}

const Holder = styled('div')<{ isOpen: boolean; heightValue: number }>(({ theme, isOpen, heightValue }) => ({
  backgroundColor: theme.palette.background.paper,
  transition: 'margin-top 0.4s',
  marginTop: isOpen ? heightValue : '0px',
}));

export const Layout = ({ noLargeDownHeader }: LayoutProps) => {
  const { isLargeDown } = useBreakpoints();
  const [toReturn, setToReturn] = useState<null | JSX.Element>(null);
  const { isAuthenticated } = useAuth();
  const [isHotelSearchOpen, _setIsHotelSearchOpen] = useState(false);
  const [isFlightsSearchOpen, setIsFlightsSearchOpen] = useState(false);
  const agencyId = Number(CONFIG.AGENCY_ID);

  useTravelServicesUpdates(isAuthenticated ? agencyId : undefined);

  useEffect(() => {
    const handler = setTimeout(() => {
      setToReturn(<PrivateLogin />);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [setToReturn]);

  if (isAuthenticated) {
    return (
      <InboxProvider>
        <Holder
          isOpen={isFlightsSearchOpen}
          heightValue={isHotelSearchOpen ? HOTEL_SEARCH_UNDER_HEADER_HEIGHT : FLIGHT_SEARCH_UNDER_HEADER_HEIGHT}
        >
          {isLargeDown && noLargeDownHeader ? undefined : <Header onOpenFlightsSearch={setIsFlightsSearchOpen} />}
          <Outlet />
        </Holder>
      </InboxProvider>
    );
  }

  return toReturn;
};
